// IMPORTANT THIS POLYFILL MUST BE INCLUDED BEFORE any RNW (react-native) imports
import 'resize-observer-polyfill/dist/ResizeObserver.global';
// import './app/assets/icons/favicon.png';
// import './apple-app-site-association';
// import './apple-developer-merchantid-domain-association.txt';
// import './assetlinks';
import './manifest';
// import './yandex_7c55496cff58a94d.html'; // this file has to be included for 'webmaster.yandex.ru'

import React from 'react';
import { AppRegistry } from 'react-native';
// import { AppContainer } from 'react-hot-loader';

import styles from './app/styles/index';
import App from './app/index';

if (module.hot) {
  // $FlowFixMe
  module.hot.accept();
}

AppRegistry.registerComponent('AI on Rails', () => App);
AppRegistry.runApplication('AI on Rails', {
  rootTag: document.getElementById('root'),
});